import { render, staticRenderFns } from "./DiscountFormulaInput.vue?vue&type=template&id=bf467cf8&"
import script from "./DiscountFormulaInput.vue?vue&type=script&lang=ts&"
export * from "./DiscountFormulaInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports